module.exports = __webpack_public_path__ + "img/MES.23969701.png";